import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "emailField"];

  connect() {
    this.toggleEmailField();
  }

  change() {
    this.toggleEmailField();
  }

  toggleEmailField() {
    if (this.selectTarget.value === "email") {
      this.emailFieldTarget.style.display = "block";
    } else {
      this.emailFieldTarget.style.display = "none";
    }
  }
}